import type { ReactNode } from 'react';

interface Props {
  label: string;
  value: ReactNode;
  monospace?: boolean;
}

/** Labeled key/value row used inside boxes and forms. */
export function Field({ label, value, monospace }: Props) {
  return (
    <div className="field">
      <span className="field-label">{label}</span>
      <span className={`field-value ${monospace ? 'mono' : ''}`}>{value}</span>
    </div>
  );
}
